<template src="./index.html">
</template>
<script>
	import {
		getdata
	} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				headDatas: getdata().headDatas
			};
		},
		props: {
			showpz: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
			tableDatas: {
				type: Array,
				default: [],
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			spanmethods({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 28) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 2) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}  else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 3) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 35) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 36) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 37) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 38) {
						return {
							rowspan: 1,
							colspan: 4
						};
					} else if (rowIndex === 39) {
						return {
							rowspan: 1,
							colspan: 4
						};
					}  else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 35) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 36) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 37) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 38) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 39) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 41) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 2) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 35) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 36) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 37) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 38) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 39) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}  else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 3) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 15) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 35) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 36) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 37) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 38) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 39) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}  else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
